module.exports = __webpack_public_path__ + "static/media/carousel8.b94b539a.jpeg";